import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export const syncWorkflowExecution = async (serviceRequestId: string) => {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/${serviceRequestId}/sync-workflow-execution`,
      {
        method: 'POST',
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};
